import * as _ from "lodash";
import {BaseInternalView} from "../_BaseViews";
import {Intercom} from "../../common/intercom";
import {SensorConfigView} from "./SensorConfigView";
import {InstallationView} from "./InstallationView";
import {PriorityInstallDashboards} from "../../collections/PriorityDashboardInstalls";
import {InstallationLayoutView} from "./InstallationLayoutView";

var template = require('templates/settings/settings.html');
var navigationLinks = require('templates/settings/navigationlinks.html');
navigationLinks = _.template(navigationLinks);

export class SettingsView extends BaseInternalView {
    template = _.template(template);

    private currentInstallId: number;
    private currentModuleId: number;
    private currentCategory: string;
    private currentOrgId: number;
    private priorityInstallDashboards: PriorityInstallDashboards;


    constructor(options) {
        super(<any> _.extend(options, {
            tagName: 'div',
        }));
    }

    show(orgId, installId, moduleId, category) {
        this.currentOrgId = Number(orgId);
        this.currentInstallId = Number(installId);
        this.currentModuleId = Number(moduleId);
        this.currentCategory = category;
        this.priorityInstallDashboards = new PriorityInstallDashboards([], {installId: this.currentInstallId});

        this.render();
    }

    setNavigationLinks() {
        this.$('nav').html(navigationLinks({
            permissionCollection: this.options.permissionCollection,
            installCollection: this.options.installCollection,
            currentInstallId: this.currentInstallId,
            currentCategory: this.currentCategory,
            currentModuleId: this.currentModuleId,
            currentOrgId: this.currentOrgId
        }));
    }

    setNavPriorityIds() {
        var channels = this.options.dashboardChannelCollection.where({install_id: Number(this.currentInstallId)});
        window['App'].Bus.trigger('priority:installs', [this.currentInstallId]);
        $.when(this.priorityInstallDashboards.getCollectionFetchPromise()).then(() => {
            window['App'].Bus.trigger('priority:dashboards', this.priorityInstallDashboards.map((dashboard) => {return dashboard.get('dashboard_id')}));
        })
    }

    render() {
        this.$el.html(this.template({}));
        this.renderSubViews();
        this.setNavigationLinks();
        this.setNavPriorityIds();

        return this;
    }

    renderSubViews() {
        var subview;
        switch (this.currentCategory) {
            case 'sensorconfig':
                subview = new SensorConfigView({
                    orgId: this.currentOrgId,
                    installId: this.currentInstallId,
                    moduleId: this.currentModuleId,
                    installCollection: this.options.installCollection,
                    permissionCollection: this.options.permissionCollection,
                    organizationCollection: this.options.organizationCollection,
                    dashboardChannelCollection: this.options.dashboardChannelCollection,
                    currentUser: this.options.currentUser
                });
                Intercom.trackEvent('viewed-settings-sensor-configuration', {
                    install_id: this.currentInstallId,
                    module_id: this.currentModuleId
                });
                break;
                case 'layout':
                    subview = new InstallationLayoutView({
                        orgId: this.currentOrgId,
                        installId: this.currentInstallId,
                        moduleId: this.currentModuleId,
                        installCollection: this.options.installCollection,
                        permissionCollection: this.options.permissionCollection,
                        organizationCollection: this.options.organizationCollection,
                        dashboardChannelCollection: this.options.dashboardChannelCollection,
                        currentUser: this.options.currentUser,
                        appRegistry: this.options.appRegistry,
                        appCollection: this.options.appCollection,
                        brandCollection: this.options.brandCollection,
                        dashboardCollection: this.options.dashboardCollection,
                    });
                    Intercom.trackEvent('viewed-settings-install-layout', {
                        install_id: this.currentInstallId,
                        module_id: this.currentModuleId
                    });
                break;
            default:
                subview = new InstallationView({
                    installId: this.currentInstallId,
                    moduleId: this.currentModuleId,
                    orgId: this.currentOrgId,
                    installCollection: this.options.installCollection,
                    permissionCollection: this.options.permissionCollection,
                    organizationCollection: this.options.organizationCollection,
                    dashboardChannelCollection: this.options.dashboardChannelCollection
                });
                Intercom.trackEvent('viewed-settings-install', {
                    install_id: this.currentInstallId,
                    module_id: this.currentModuleId
                });
                break;
        }
        if(subview) subview.show();
    }
}


// WEBPACK FOOTER //
// ./srv/public/js/views/settings/SettingsView.ts